import React from 'react';
import styled from 'styled-components';

function TreeContent(props) {
	const {children} = props;

	return <StyledTreeContent className={'tree-content'}>{children}</StyledTreeContent>;
}

const StyledTreeContent = styled.section``;

export default TreeContent;
